import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";

const ORIGIN = API.replace(/\/api$/, "");
let cache = null;

export function useBranding() {
  const [branding, setBranding] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get("/branding/public").then((r) => { cache = r.data; setBranding(r.data); }).catch(() => {});
  }, []);
  const asset = (url) => (url ? `${ORIGIN}${url}` : "");
  return { branding, asset };
}
